import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
// import LegacyInterceptor from '@finx/web-repository/src/apis/Legacy/LegacyInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()
// const api = new LegacyInterceptor()

export default {
  async get(solicitacaoId: string) {
    const request = await api.get(`/solicitacoes/${solicitacaoId}/contestacoes/aberta`)
    return factory.build(request)
  },

  async getAll(solicitacaoId: string) {
    const request = await api.get(`/solicitacoes-backoffice/${solicitacaoId}`)
    return factory.build(request)
  },

  async uploadDocumento(hospitalId: string, formData: any) {
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }

    const request = await api.upload(`/hospitais/${hospitalId}/documentos/upload/Contestacao`, formData, header)
    return factory.build(request)
  },

  async abrirContestacao(solicitacaoId: string, data: any) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/abrir`, data)
    return factory.build(request)
  },

  async enviarMensagem(solicitacaoId: string, data: any) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/mensagens/enviar`, data)
    return factory.build(request)
  },

  async recusarContestacao(solicitacaoId: string) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/recusar`, {})
    return factory.build(request)
  },

  async aceitarContestacao(solicitacaoId: string) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/aceitar`, {})
    return factory.build(request)
  },

  async aceitarRecusaDeContestacao(solicitacaoId: string) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/aceitar-recusa`, {})
    return factory.build(request)
  },
}
